export default __webpack_public_path__ + "static/media/order.02e37d5b.svg";